import { ConversationSummary } from '../core/hub-types';

/**
 * The patient file a conversation is about, in THIS app, or null: a patient chat (unless it belongs to another app),
 * this practice's own patient in a referral chat (none for a clinician outside MedicAI), or the patient in their
 * patient-app chat (the practice side). Groups and direct messages are about no one patient.
 */
export function patientFileRef(c: ConversationSummary | null | undefined): string | null {
  if (!c) return null;
  switch (c.type) {
    case 'patient':
      return (c.patientSystem ?? 'clinical') === 'clinical' ? c.patientRef ?? null : null;
    case 'referral':
      return c.referral?.patientRef ?? null;
    case 'patient_direct':
      return c.patientDirect?.patientRef ?? null;
    default:
      return null;
  }
}
